export const DARK_COLOR = '#ffffff';
export const LIGHT_COLOR = '#333333';

export const DARK_BACKGROUND = '#1f1f1f';
export const DARK_BORDER = '#303030';
export const DARK_TEXT_SECONDARY = '#888888';

export const LIGHT_BACKGROUND = '#ffffff';
export const LIGHT_BORDER = '#e8e8e8';
export const LIGHT_TEXT_SECONDARY = '#666666';

export const getTextColor = (isDark: boolean): string => {
  return isDark ? DARK_COLOR : LIGHT_COLOR;
};

export const getBackgroundColor = (isDark: boolean): string => {
  return isDark ? DARK_BACKGROUND : LIGHT_BACKGROUND;
};

export const getBorderColor = (isDark: boolean): string => {
  return isDark ? DARK_BORDER : LIGHT_BORDER;
};
